import FormBlock from 'components/formComponents/Layout/FormBlock';
import ApplicationTypeBlock from './ApplicationTypeBlock';
import ApplicantRoleSelect from './ApplicantRoleSelect';
import { useAppSelector } from '../../../../../hooks';
import { useMemo } from 'react';
import MoreApplicationsSelect from './MoreApplicationsSelect';

const StartSection = () => {
  const { pageTexts } = useAppSelector((state) => state.partyApplication);
  const texts = useMemo(() => {
    return pageTexts?.startTexts;
  }, [pageTexts]);
  return (
    <FormBlock title={texts?.startHeadline}>
      <ApplicationTypeBlock texts={texts} />
      <ApplicantRoleSelect texts={texts} />
      <MoreApplicationsSelect texts={texts} />
    </FormBlock>
  );
};

export default StartSection;
